import { boolean, number, object } from 'yup'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { designProject } from 'components/Wizards/schemas/shared/designProject'
import { sourceVisualElementId } from 'components/Wizards/schemas/shared/sourceVisualElementId'
import { safify } from 'components/Wizards/schemas/utils/safify'
import { MultiStepSchema } from 'components/Wizards/schemas/Types'
import { meta } from '../schemaCommon'
import { DesignChannel } from 'components/NewFileModal/Types'

const PickAnImage = object({
  initial_media_file_id: number().default(undefined).transform(safify),
}).meta({
  title: 'Pick an image',
  supportedMediaTypes: ['image'],
})

const ConfirmYourImage = object({
  initial_media_file_remove_background: boolean().default(false),
  width: number().required(),
  height: number().required(),
  filename,
  project: designProject,
}).meta({
  title: 'Confirm your Image',
})

const PickYourBackground = object({
  source_visual_element_id: sourceVisualElementId,
}).meta({
  title: 'Pick your Background',
})

const ViewYourDesign = object({}).meta({
  title: 'View your Design',
})

export const FlowBSchema = ({ generationType }: { generationType: string }) =>
  ({
    meta,
    steps: [PickAnImage, ConfirmYourImage, PickYourBackground, ViewYourDesign],
  } as MultiStepSchema<DesignChannel>)
